var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('base-crud',{attrs:{"crudName":"Itens de Checklist","newText":"Novo Item de Checklist","table":_vm.table,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":true,"enableEdit":true,"enableDelete":true,"enableView":false,"dataForm":_vm.dataForm}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bed5c1e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckListItem/Crud.vue
// module id = null
// module chunks = 